<template>
    <v-dialog v-model="gmgmwdialog" max-width="800">
        <v-card>
            <v-container fluid>
                <h1>GM to GMW Bill</h1>
                <v-form @submit.prevent="" v-model="valid">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Start Date" v-model="startdate" type='date' :rules="startDateRules" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="End Date" v-model="enddate" type='date' :rules="endDateRules" required></v-text-field>
                        </v-col>
                    </v-row>
                    <!-- <v-text-field label="Bill Date" v-model="bill.billdate" type='date' required></v-text-field> -->
                    <v-data-table class="mb-2"
                        v-model="selected"
                        :headers="headers"
                        :items="filteredBills"
                        item-value="billid"
                        return-object
                        show-select
                        :items-per-page="itemsPerPage"
                        select-strategy="single"
                        hide-default-footer
                    >
                    
                    </v-data-table>
                    
                    <v-row justify="center">
                        <v-btn
                            depressed
                            color="primary"
                            type="submit"
                            @click=buttonClick()
                        >
                            Update
                        </v-btn>
                    </v-row>
                    
                </v-form>
                <div v-if="showMessage">
                    <ShowError @closesnackbar="closesnackbar"/>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script setup>
    import { ref, provide, computed, onMounted,onBeforeMount,watch } from 'vue'
    import BillService from '@/services/BillService'
    import BatchService from '@/services/BatchService'
    import YearService from '@/services/YearService'
    import ProductService from '@/services/ProductService'
    import ShowError from '@/components/Showerror'
    
    const props = defineProps(['showGmGmwForm'])
    const emit = defineEmits(['closegmgmwdialog'])

    const valid = ref(false)

    const startDateRules = [
        v => !!v || 'Start Date is required'
    ]

    const endDateRules = [
        v => !!v || 'End Date is required'
    ]
    var showMessage = ref(false)
    var msgStatus = ref('primary')
    var msg = ref('This is msg')
    var bill = ref({
        console:'GM1',
        bills_partyname:'M/S GM Pharmaceuticals',
        bills_state:'West Bengal',
        caseno:30,
        transport:'Motor Van'
    })
    var batches = ref([])
    var years = ref([])
    var productnames = ref([])
    var gmgmwdialog = ref(props.showGmGmwForm)

    var startdate=ref('')
    var enddate=ref('')
    var billdate=ref('')
    var billid = ref()

    var gmwbills = ref([])
    var billdatesearch = ref('')
    var billnosearch = ref('')
    var partysearch = ref('')
    var amountsearch = ref('')
    var headers = ref([
        {
          title: 'Bill No',
          align: 'start',
          sortable: true,
          key: 'billno',
        },
        { title: 'Bill Date', key: 'billdate' },
        { title: 'Partyname', key: 'bills_partyname' },
        { title: 'Amount', key: 'billamount' },
    ])
    const itemsPerPage = ref(5)

    var selected= ref([])

    provide('msgStatus', msgStatus)
    provide('msg', msg)
    provide('showMessage', showMessage)

    async function create(){
        console.log("Creating bill")
        try{
            await BillService.create(bill.value)
            gmgmwdialog.value = false
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        
    }

    async function update(){
        console.log("Updating bill")
        try{
            await BillService.update(bill.value, billid.value)
            gmgmwdialog.value = false
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        
    }

    async function buttonClick(){
        if(valid.value){
            var sales = (await BillService.getgmsalesgmw(startdate.value, enddate.value)).data
           
            
            if(selected.value.length == 0){
                showMessage.value = true
                msgStatus.value = 'error'
                msg.value = "Please select a row."
            }else{
                var selectedbill = selected.value[0]
                bill.value = selectedbill
                billid.value = selectedbill.billid

                for (let i = 0; i < sales.length; i++){
                    sales[i].productsales_ebillid =  selectedbill.bills_ebillid,
                    sales[i].productsales_partyname = selectedbill.bills_partyname,
                    sales[i].year = selectedbill.bills_year,
                    sales[i].console = selectedbill.console,
                    sales[i].billno = selectedbill.billno,
                    sales[i].billdate = selectedbill.billdate,
                    sales[i].itemid = (await getitemid(sales[i].productname, sales[i].batchno)),
                    sales[i].discount = 0,
                    sales[i].rate = (await getrate(sales[i].productname))
                    sales[i].id = "",
                    sales[i].newmrp = 0
                }

                for (let j = 0; j < sales.length; j++){
                    if(sales[j].itemid == 0){
                        sales.splice(j,1)
                    }
                }

                bill.value.productsales = sales
                await gettotalvalue()
                await update()
            }
            
        }else{
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = "Please select Start Date and End date."
        }
        
    }

    async function gettotalvalue(){

        console.log("Checking bills in get total value")
        console.log(bill.value)
        var taxable = 0
        var igst = 0
        var cgst = 0
        var sgst = 0
        
        for(let i = 0; i < bill.value.productsales.length; i++){
            var rate = Number(bill.value.productsales[i].rate)
            var qty = Number(bill.value.productsales[i].qty)
            var discountpercent = Number(bill.value.productsales[i].discount)
            var igstpercent = Number(bill.value.productsales[i].igst_rate)
            var cgstpercent = Number(bill.value.productsales[i].cgst_rate)
            var sgstpercent = Number(bill.value.productsales[i].sgst_rate)
            var value = Math.round((rate * qty) * 100) / 100
            var discountvalue = Math.round((value * discountpercent /100) * 100) / 100
            var eachtaxable = Math.round((value - discountvalue) * 100) / 100
            var igstvalue = Math.round((eachtaxable * igstpercent / 100) * 100) / 100
            var cgstvalue = Math.round((eachtaxable * cgstpercent / 100) * 100) / 100
            var sgstvalue = Math.round((eachtaxable * sgstpercent / 100) * 100) / 100
            taxable = Math.round((taxable + eachtaxable) * 100) / 100
            igst = Math.round((igst + igstvalue) * 100) / 100
            cgst = Math.round((cgst + cgstvalue) * 100) / 100
            sgst = Math.round((sgst + sgstvalue) * 100) / 100
            //console.log('Taxable is '+i+' ---  '+eachtaxable)
        }

        bill.value.total = taxable
        bill.value.bills_igst = igst
        bill.value.bills_cgst = cgst
        bill.value.bills_sgst = sgst
        var billamount = Math.round(taxable + igst + cgst + sgst)
        bill.value.billamount = billamount
        bill.value.overdue = billamount
        bill.value.amount = billamount
        //console.log("billamount "+bill.value.billamount)
    }

    async function getebillid(){
        try{
            var ebillid = (await BillService.getebillid()).data
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        bill.value.bills_ebillid = ebillid.ebillid
        return ebillid
    }

    async function getnum(year,con){
        try{
            var num = (await BillService.getnum(year,con)).data
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        bill.value.num = num.num
        bill.value.billno = num.billno
        return num
    }

    async function getbatches(){
        try{
            var batch = (await BatchService.getall()).data
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        batches.value = batch
        return batch
    }

    async function getsmrates(){
        try{
            var product = (await ProductService.getsmrates()).data
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        productnames.value = product
        return product
    }

    async function getyear(){
        try{
            var year = (await YearService.getall()).data
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        years.value = year
        bill.value.bills_year = year[0].year_year
        return year
    }

    async function getitemid(selectedproduct, selectedbatch){
        var itemid = 0
        var itemidarray = batches.value.filter(function(el){
                return el.productname == selectedproduct &&
                        el.batchno == selectedbatch
                })
                if(itemidarray.length > 0){
                    itemid = itemidarray[0].itemid
                }
        return itemid
    }

    async function getrate(selectedproduct){
        var itemid = 0
        var itemidarray = productnames.value.filter(function(el){
                return el.productnames_productname == selectedproduct
                })
                if(itemidarray.length > 0){
                    itemid = itemidarray[0].sm_rate
                }
        return itemid
    }

    async function getgmwbils(){
        try{
            var bills = (await BillService.getallgmwbills()).data

            const sixtyDaysInMs = 60 * 24 * 60 * 60 * 1000;
            const threshold = new Date(Date.now() - sixtyDaysInMs);

            const filteredData = bills.filter(item => {
                return new Date(item.billdate) > threshold;
            });

            gmwbills.value = filteredData
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        return bills
    }

    onBeforeMount(async () => {
        await getgmwbils()
        await getbatches()
        await getyear()
        await getebillid()
        await getnum(bill.value.bills_year, 'GM1')
        await getsmrates()
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        var datetopass = yyyy + '-' + mm + '-' + dd;
        
    })

    watch(gmgmwdialog, async(val)=>{
        if(gmgmwdialog.value===false){
            //console.log("Form is closed")
            emit('closegmgwdialog')
        }
    })

    function filterBillno(item){
        return item.billno.toLowerCase().includes(billnosearch.value.toLowerCase())
    }
    function filterBilldate(item){
        return item.billdate.toLowerCase().includes(billdatesearch.value.toLowerCase())
    }

    function filterParty(item){
        return item.bills_partyname.toLowerCase().includes(partysearch.value.toLowerCase())
    }

    function filterAmount(item){
        return item.billamount >= amountsearch.value
    }

    const filteredBills = computed(() => {
        var conditions = []

        if(billnosearch.value){
            conditions.push(filterBillno)
        }

        if(billdatesearch.value){
            conditions.push(filterBilldate)
        }

        if(partysearch.value){
            conditions.push(filterParty)
        }

        if(amountsearch.value){
            conditions.push(filterAmount)
        }

        if(conditions.length > 0){
            return gmwbills.value.filter((bill) => {
                return conditions.every((condition) => {
                    return condition(bill)
                })
            })
        }

        return gmwbills.value
    })

</script>